import React, { useState } from 'react';
import { Card, Table, Button, Input, Space, Tag, Typography, Row, Col } from 'antd';
import { SearchOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { Search } = Input;

interface TrafficCard {
  key: string;
  id: string;
  cardNumber: string;
  iccid: string;
  status: 'active' | 'inactive' | 'expired';
  dataUsage: number;
  totalData: number;
  expireDate: string;
  operator: string;
  createTime: string;
}

const TrafficCardList: React.FC = () => {
  const [loading, setLoading] = useState(false);

  // 模拟数据
  const mockData: TrafficCard[] = [
    {
      key: '1',
      id: 'TC001',
      cardNumber: '13800138001',
      iccid: '89860012345678901234',
      status: 'active',
      dataUsage: 2.5,
      totalData: 10,
      expireDate: '2024-12-31',
      operator: '中国移动',
      createTime: '2024-01-01',
    },
    {
      key: '2',
      id: 'TC002',
      cardNumber: '13800138002',
      iccid: '89860012345678901235',
      status: 'inactive',
      dataUsage: 0,
      totalData: 5,
      expireDate: '2024-06-30',
      operator: '中国联通',
      createTime: '2024-01-02',
    },
    {
      key: '3',
      id: 'TC003',
      cardNumber: '13800138003',
      iccid: '89860012345678901236',
      status: 'expired',
      dataUsage: 8.2,
      totalData: 8,
      expireDate: '2024-01-15',
      operator: '中国电信',
      createTime: '2024-01-03',
    },
  ];

  const columns = [
    {
      title: '卡号',
      dataIndex: 'cardNumber',
      key: 'cardNumber',
    },
    {
      title: 'ICCID',
      dataIndex: 'iccid',
      key: 'iccid',
      width: 200,
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => {
        const statusMap = {
          active: { text: '正常', color: 'green' },
          inactive: { text: '停用', color: 'orange' },
          expired: { text: '过期', color: 'red' },
        };
        const statusInfo = statusMap[status as keyof typeof statusMap];
        return <Tag color={statusInfo.color}>{statusInfo.text}</Tag>;
      },
    },
    {
      title: '已用流量',
      dataIndex: 'dataUsage',
      key: 'dataUsage',
      render: (usage: number, record: TrafficCard) => `${usage}GB / ${record.totalData}GB`,
    },
    {
      title: '运营商',
      dataIndex: 'operator',
      key: 'operator',
    },
    {
      title: '到期时间',
      dataIndex: 'expireDate',
      key: 'expireDate',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    {
      title: '操作',
      key: 'action',
      render: (record: TrafficCard) => (
        <Space size="middle">
          <Button type="link" size="small">查看</Button>
          <Button type="link" size="small">编辑</Button>
          <Button type="link" size="small" danger>删除</Button>
        </Space>
      ),
    },
  ];

  const handleSearch = (value: string) => {
    console.log('搜索:', value);
  };

  const handleRefresh = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  return (
    <div>
      <Card>
        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          <Col>
            <Title level={3}>流量卡列表</Title>
          </Col>
          <Col>
            <Space>
              <Button icon={<PlusOutlined />} type="primary">
                新增流量卡
              </Button>
              <Button icon={<ReloadOutlined />} onClick={handleRefresh}>
                刷新
              </Button>
            </Space>
          </Col>
        </Row>

        <Row justify="space-between" style={{ marginBottom: 16 }}>
          <Col>
            <Search
              placeholder="搜索卡号、ICCID"
              allowClear
              enterButton={<SearchOutlined />}
              style={{ width: 300 }}
              onSearch={handleSearch}
            />
          </Col>
          <Col>
            <Space>
              <Button>批量操作</Button>
              <Button>导出数据</Button>
            </Space>
          </Col>
        </Row>

        <Table
          columns={columns}
          dataSource={mockData}
          loading={loading}
          pagination={{
            total: mockData.length,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条/共 ${total} 条`,
          }}
        />
      </Card>
    </div>
  );
};

export default TrafficCardList; 